/**
 * @file
 * Scripts for Blogs page.
 */

const $context = $('.cpl-blog-page-block', context);
$context.once('blog-page-block').each((index, el) => {
  // Disable equalizer from base theme.
  $(el).foundation('destroy');
});
